// this is an autogenerated file from App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/Settings/Content/StartJob/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_PaymentProviders_Accounts_Content_ProviderAccount_Settings_Content_StartJob_Content($account_id: String!) {
  payments_token_fee_eligibility_jobs(
    where: { account_id: { _eq: $account_id }, status: { _eq: in_progress } }
    order_by: { created_at: desc }
    limit: 1
  ) {
    id
    status
    number_of_processed_tokens
    total_number_of_tokens
  }
  payments_tokens(
    where: {
      # find the tokens not yet acknowledged for platform fee
      fee_acknowledged_by_user_id: { _is_null: true }
      fee_acknowledged_by_person_id: { _is_null: true }
      provider_location_account: {
        provider: { _eq: payabli }
        account_id: { _eq: $account_id }
      }
      # exclude tokens used in an insurance payment transaction
      _not: {
        transactions: { vaxiom_payment: { insured_id: { _is_null: false } } }
      }
      _or: [
        { provider_location_account: { fee_mode: { _eq: PLATFORM_FEE } } }
        {
          # surcharge only supports credit card transactions
          provider_location_account: { fee_mode: { _eq: SURCHARGE } }
          type: { _eq: card }
        }
      ]
    }
    limit: 1
  ) {
    id
  }
}

`